import React, { useState } from 'react';
import axios from '../axios';

// Small mark next to an APPROVED order's status: Rabbi's final approval (given on Telegram).
// Approvers (Rabbi, Alvee, Admin) also see a small "Approve" link here, as a backup to Telegram.
export const rabbiApproved = (order) => order.orderStatus !== 'APPROVED' || order.finalApproval === 'Approved';

export function scheduleBlockedMessage(order) {
    return order.finalApproval === 'EditedWaiting'
        ? 'This order was edited after Rabbi approved it. It needs his approval again before it can be scheduled.'
        : "This order is waiting for Rabbi's approval. It cannot be scheduled yet.";
}

function RabbiMark({ order }) {
    const [busy, setBusy] = useState(false);
    if (order.orderStatus !== 'APPROVED') return null;

    const when = order.finalApprovedAt
        ? new Date(order.finalApprovedAt * 1000).toLocaleString('en-GB', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Dhaka' })
        : '';
    // Who approved (Rabbi, Alvee or Admin); orders approved before this started count as Rabbi's
    const raw = String(order.finalApprovedByName || 'Rabbi').trim();
    const who = raw.charAt(0).toUpperCase() + raw.slice(1);
    const mark = order.finalApproval === 'Approved'
        ? { text: `✔ ${who}`, color: '#198754', title: `Approved by ${who}${when ? ` · ${when}` : ''}` }
        : order.finalApproval === 'EditedWaiting'
            ? { text: '⏳ Rabbi', color: '#d9480f', title: 'Edited after Rabbi approved it: waiting for his approval again' }
            : { text: '⏳ Rabbi', color: '#b7791f', title: "Waiting for Rabbi's approval" };

    const approve = async (e) => {
        e.stopPropagation();
        if (!window.confirm(`Approve job ${order.jobNo}?`)) return;
        setBusy(true);
        try {
            await axios.post(`${window.backendUrl}/orders/${order.orderId}/final-approve`);
            window.location.reload();
        } catch (err) {
            alert(err?.response?.data?.error || 'Could not approve');
            setBusy(false);
        }
    };

    return (
        <div style={{ fontSize: '10px', lineHeight: 1.3, marginTop: '2px', whiteSpace: 'nowrap' }}>
            <span title={mark.title} style={{ color: mark.color, fontWeight: 600 }}>{mark.text}</span>
            {order.finalApprover && order.finalApproval !== 'Approved' && (
                <span onClick={busy ? undefined : approve} style={{ marginLeft: '6px', color: '#0d6efd', textDecoration: 'underline', cursor: busy ? 'default' : 'pointer' }}>
                    {busy ? '…' : 'Approve'}
                </span>
            )}
        </div>
    );
}

export default RabbiMark;
